import React, {useState, useEffect} from 'react';
import ProjectsInner from './ProjectsInner';
import YourProjects from './YourProjects';
import {mainPath} from '../../routes/paths';

import {ReactComponent as ContentIcon} from '../../assets/icons/content.svg';
import {ReactComponent as MenuIcon} from '../../assets/icons/menu.svg';
import './Projects.scss';
import {Route, Switch, useHistory, useLocation} from 'react-router-dom';
import {useTranslation} from "react-i18next";

const Projects = () => {
  const [isMenuVisible, setMenuVisible] = useState(false);
  const [isYourContentVisible, setYourContentVisible] = useState(true);
  const [isInnerVisible, setInnerVisible] = useState(true);
  const history = useHistory();
  const location = useLocation();
  const {t} = useTranslation();
  const handleNavLinkClick = () => {
    if (window.innerWidth < 1080) {
      setYourContentVisible(false);
      setInnerVisible(true);
      setMenuVisible(false);
    }
  };

  const toggleMenu = () => {
    setMenuVisible(true);
    setYourContentVisible(false);
    setInnerVisible(false);
  };

  const toggleYourContent = () => {
    history.push(mainPath.projects);
    setYourContentVisible(true);
    setMenuVisible(false);
    setInnerVisible(false);
  };

  const handleProjectSelect = () => {
    if (window.innerWidth >= 1690) {
      setMenuVisible(true);
      setInnerVisible(true);
      setYourContentVisible(true);
    }

    if (window.innerWidth < 1690) {
      setMenuVisible(true);
      setInnerVisible(true);
      setYourContentVisible(false);
    }

    if (window.innerWidth < 1080) {
      setYourContentVisible(false);
      setInnerVisible(false);
      setMenuVisible(true);
    }
  };

  useEffect(() => {
    const handleResize = () => {
      const pathSegments = location.pathname.split('/').filter(Boolean);
      const isProjectPage = pathSegments.length > 2 && pathSegments.length <= 3;
      const isInnerPage = pathSegments.length > 3;
      const isNarrowScreen = window.innerWidth < 1080;
      const isWidderScreen = window.innerWidth > 1080 && window.innerWidth < 1690;

      if (isProjectPage) {
        setMenuVisible(true);
        setInnerVisible(!isNarrowScreen);
        setYourContentVisible(!isNarrowScreen && !isWidderScreen);
      } else if (isInnerPage) {
        setMenuVisible(!isNarrowScreen);
        setInnerVisible(true);
        setYourContentVisible(!isNarrowScreen && !isWidderScreen);
      } else {
        setMenuVisible(false);
        setInnerVisible(false);
        setYourContentVisible(true);
      }
    };
    window.addEventListener('resize', handleResize);
    handleResize();
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [location]);

  return (
    <div className={`page projects-page${isInnerVisible ? ' inner-visible' : ''}`}>
      {!isMenuVisible && !isYourContentVisible && (
        <div className='hidden-menu'>
          <div className='hidden-menu__content' onClick={toggleYourContent}>
            <ContentIcon />
              {t("SideBgItems.projects")}
          </div>
          <div className='hidden-menu__menu' onClick={toggleMenu}>
            <MenuIcon />
              {t('profile.menu')}
          </div>
        </div>
      )}
      {isYourContentVisible && <YourProjects handleProjectSelect={handleProjectSelect} />}

      <Switch>
        <Route
          path={mainPath.project}
          render={(props) => (
            <ProjectsInner
              {...props}
              handleNavLinkClick={handleNavLinkClick}
              toggleYourContent={toggleYourContent}
              isYourContentVisible={isYourContentVisible}
              isMenuVisible={isMenuVisible}
              isInnerVisible={isInnerVisible}
            />
          )}
        />
      </Switch>
    </div>
  );
};

export default Projects;
